import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "container page-frame" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col col-lg-8 container invoice-table" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col text-right" }
const _hoisted_8 = { class: "wrap-text" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col text-right" }
const _hoisted_11 = { class: "wrap-text" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col text-right" }
const _hoisted_14 = { class: "wrap-text" }
const _hoisted_15 = { class: "row billing-amount-row" }
const _hoisted_16 = { class: "col text-right" }
const _hoisted_17 = { class: "wrap-text" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col text-right" }
const _hoisted_20 = { class: "wrap-text" }
const _hoisted_21 = { class: "row justify-content-center my-2" }
const _hoisted_22 = { class: "col col-lg-8 container" }
const _hoisted_23 = { class: "invoice-approved" }
const _hoisted_24 = { class: "extract-button" }
const _hoisted_25 = { class: "message-thread container my-2" }
const _hoisted_26 = { class: "col-8 text-left" }
const _hoisted_27 = { class: "col-4 align-self-center" }
const _hoisted_28 = { class: "wrap-text" }
const _hoisted_29 = {
  class: "message-thread message-thread-height-measure-dummy-div container my-2",
  ref: "messageThreadHeightMeasureDummyDiv"
}
const _hoisted_30 = { class: "col-8 text-left" }
const _hoisted_31 = { class: "col-4 align-self-center" }
const _hoisted_32 = { class: "wrap-text" }
const _hoisted_33 = ["disabled"]
const _hoisted_34 = { class: "invoice-disapproved" }
const _hoisted_35 = { class: "row justify-content-between table-title-row" }
const _hoisted_36 = { class: "row mt-2" }
const _hoisted_37 = { class: "col search-text-wrap" }
const _hoisted_38 = { class: "row" }
const _hoisted_39 = { class: "col" }
const _hoisted_40 = { class: "table" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Breadcrumbs, {
      here: '月払い請求書発行',
      ancestries: _ctx.ancestries
    }, null, 8, ["ancestries"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "col h2",
        style: _normalizeStyle({ fontSize: _ctx.FontSizes.large1})
      }, _toDisplayString(_ctx.staff.userName) + "さんの月払い請求書発行ページ", 5)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: "col h3",
        style: _normalizeStyle({ fontSize: _ctx.FontSizes.middle1})
      }, _toDisplayString(_ctx.lastMonthText) + "末締めの月払い請求書発行", 5)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "col" }, [
            _createElementVNode("span", { class: "wrap-text" }, "配布委託料")
          ], -1)),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, "¥" + _toDisplayString(_ctx.totalAmount.toLocaleString(undefined, { minimumFractionDigits: 3, maximumFractionDigits: 3 })) + "円", 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "col" }, [
            _createElementVNode("span", { class: "wrap-text" }, "前払い利用済み金額")
          ], -1)),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("span", _hoisted_11, "¥" + _toDisplayString(_ctx.prepaidAmount.toLocaleString()) + "円", 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "col" }, [
            _createElementVNode("span", { class: "wrap-text" }, "配布委託料残高")
          ], -1)),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("span", _hoisted_14, "¥" + _toDisplayString(_ctx.compensationBalance.toLocaleString(undefined, { minimumFractionDigits: 3, maximumFractionDigits: 3 })) + "円", 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "col" }, [
            _createElementVNode("span", { class: "wrap-text" }, "請求金額（消費税込み）")
          ], -1)),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("span", _hoisted_17, "¥" + _toDisplayString(_ctx.billingAmount.toLocaleString()) + "円", 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "col" }, [
            _createElementVNode("span", { class: "wrap-text" }, "振込手数料")
          ], -1)),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("span", _hoisted_20, "¥" + _toDisplayString(_ctx.transferFee.toLocaleString()) + "円", 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("button", {
          class: "btn btn-primary w-100",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClickSubmitInvoice && _ctx.onClickSubmitInvoice(...args)))
        }, "この金額で請求書を発行する"),
        _withDirectives(_createElementVNode("div", null, [
          _cache[12] || (_cache[12] = _createTextVNode("請求書を発行すると", -1)),
          _createElementVNode("span", _hoisted_23, "★" + _toDisplayString(_ctx.approvedText), 1),
          _cache[13] || (_cache[13] = _createTextVNode("となります。", -1))
        ], 512), [
          [_vShow, !_ctx.invoiceApproval.accept]
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["approval-state my-2", _ctx.invoiceApproval.accept ? 'invoice-approved' : 'invoice-disapproved']),
          style: _normalizeStyle({ fontSize: _ctx.FontSizes.large1})
        }, "★ " + _toDisplayString(_ctx.approvalStateText), 7),
        _createElementVNode("div", {
          class: "submit-box",
          style: _normalizeStyle({height: _ctx.submitBoxHeight + 'px'})
        }, [
          _createElementVNode("div", {
            class: "submit-box-header",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickSubmitBoxHeader && _ctx.onClickSubmitBoxHeader(...args)))
          }, [
            _createElementVNode("div", {
              class: "header-inner",
              style: _normalizeStyle({ fontSize: _ctx.FontSizes.large1})
            }, "内容問合せ", 4),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", {
                class: _normalizeClass(["arrow-mark", {'arrow-mark-inverted': _ctx.isSubmitBoxOpen}])
              }, null, 2)
            ])
          ]),
          (_ctx.existsApprovalMessageContent)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _cache[14] || (_cache[14] = _createElementVNode("div", { class: "message-tip" }, "問合せ済みメッセージ", -1)),
                _createElementVNode("div", _hoisted_25, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoiceApproval.messages, (message) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: message.vForKey,
                      style: _normalizeStyle({fontSize: _ctx.FontSizes.small1}),
                      class: "row message-row"
                    }, [
                      _createElementVNode("div", _hoisted_26, "● " + _toDisplayString(message.message), 1),
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("span", _hoisted_28, _toDisplayString(message.datetime), 1)
                      ])
                    ], 4))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_29, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoiceApproval.messages, (message) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: message.vForKey,
                      style: _normalizeStyle({fontSize: _ctx.FontSizes.small1}),
                      class: "row message-row"
                    }, [
                      _createElementVNode("div", _hoisted_30, "● " + _toDisplayString(message.message), 1),
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("span", _hoisted_32, _toDisplayString(message.datetime), 1)
                      ])
                    ], 4))
                  }), 128))
                ], 512),
                _cache[15] || (_cache[15] = _createElementVNode("div", { class: "message-tip" }, "このメッセージに追記する", -1))
              ], 64))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.messageText) = $event))
            }, null, 512), [
              [_vModelText, _ctx.messageText]
            ])
          ]),
          _createElementVNode("button", {
            class: "btn btn-secondary submit-button",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onClickSubmitMessage && _ctx.onClickSubmitMessage(...args))),
            disabled: !_ctx.canClickSubmitMessage()
          }, "メッセージを送信する", 8, _hoisted_33),
          _withDirectives(_createElementVNode("div", null, [
            _cache[16] || (_cache[16] = _createTextVNode("問合せメッセージを送信すると", -1)),
            _createElementVNode("span", _hoisted_34, "★" + _toDisplayString(_ctx.disapprovedText), 1),
            _cache[17] || (_cache[17] = _createTextVNode("となります。", -1))
          ], 512), [
            [_vShow, _ctx.invoiceApproval.accept]
          ])
        ], 4)
      ])
    ]),
    _createElementVNode("div", _hoisted_35, [
      _createElementVNode("div", {
        class: "col-6 col-md-6 h3",
        style: _normalizeStyle({ fontSize: _ctx.FontSizes.large1})
      }, _toDisplayString(_ctx.lastMonthText) + "の配布記録", 5),
      _createElementVNode("button", {
        class: "btn btn-info col-12 col-md-4 align-self-center",
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onClickDownloadInvoiceDetailExcel && _ctx.onClickDownloadInvoiceDetailExcel(...args)))
      }, "請求明細Excelファイル")
    ]),
    _createElementVNode("div", _hoisted_36, [
      _createElementVNode("div", _hoisted_37, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          placeholder: "検索",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchText) = $event))
        }, null, 512), [
          [_vModelText, _ctx.searchText]
        ]),
        _createElementVNode("div", {
          class: "clear-button",
          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onClickClearSearch && _ctx.onClickClearSearch(...args)))
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_38, [
      _createElementVNode("div", _hoisted_39, [
        _createElementVNode("table", _hoisted_40, [
          _cache[18] || (_cache[18] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, "配布日"),
              _createElementVNode("th", null, "商品ID"),
              _createElementVNode("th", null, "商品名"),
              _createElementVNode("th", null, "配布地区"),
              _createElementVNode("th", null, "配布エリア"),
              _createElementVNode("th", null, "配布数合計"),
              _createElementVNode("th", null, "配布単価"),
              _createElementVNode("th", null, "委託費合計")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchedPayAmounts, (pAmount) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: pAmount.vForKey
              }, [
                _createElementVNode("td", null, _toDisplayString(pAmount.dateString), 1),
                _createElementVNode("td", null, _toDisplayString(pAmount.productId), 1),
                _createElementVNode("td", null, _toDisplayString(pAmount.productName), 1),
                _createElementVNode("td", null, _toDisplayString(pAmount.areaAddress), 1),
                _createElementVNode("td", null, _toDisplayString(pAmount.place), 1),
                _createElementVNode("td", null, _toDisplayString(pAmount.resultCount), 1),
                _createElementVNode("td", null, "¥" + _toDisplayString(pAmount.sPrice.toFixed(3)), 1),
                _createElementVNode("td", null, "¥" + _toDisplayString(pAmount.amount.toFixed(3)), 1)
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}